import { render } from "./WhyThisMattersSection.vue?vue&type=template&id=e6bf31ee&scoped=true"
import script from "./WhyThisMattersSection.vue?vue&type=script&lang=js"
export * from "./WhyThisMattersSection.vue?vue&type=script&lang=js"

import "./WhyThisMattersSection.vue?vue&type=style&index=0&id=e6bf31ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6bf31ee"]])

export default __exports__